import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const filters = {
  element: '#content > div.page.manage-campaigns > div.page-content > div.toolbar > div.filters',
  popover: {
    title: 'Filtering Campaigns',
    description:
      'Find the campaigns you care about faster! Use the search bar to pinpoint specific campaigns or filter by tags, categories, folders, and dates to zero in on exactly what you need.',
    side: 'bottom',
    align: 'start',
    onNextClick: () => {
      const exportBtn = document.querySelector('#export-dropdown > button');

      if (exportBtn) {
        exportBtn.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
